import { FC } from "react";
import styles from './CategoryPicker.module.css';
import { CategoryButton } from "./CategoryButton";
import { getIcon } from "../utils/CategoryUtil";
import { useCategories } from "../hooks/useCategories";

interface CategoryPickerProps {
    selectedCategories: string[];
    blue?: boolean;
    maxCategories?: number;
    showAll?: boolean;
    align?: 'center' | 'start';
    className?: string;
    onChange: (categories: string[]) => void;
}

const CategoryPicker: FC<CategoryPickerProps> = ({
    showAll = true,
    selectedCategories,
    blue = false,
    align = 'center',
    className = '',
    onChange,
    maxCategories
}) => {

    const {categories, loading} = useCategories();

    const isSelected = (cat: string): boolean => {
        if(cat == "all" && selectedCategories[0] == '') { return true; }
        return selectedCategories.includes(cat);
    };

    const toggleCategory = (catSlug: string): void => {

        let cats: string[] = [];
        if(catSlug == "all") {
            cats = [''];
        }
        else {
            if (isSelected(catSlug)) {
                // If the category is selected, remove it from the array
                cats = selectedCategories.filter((c) => c !== catSlug);
            } else {
                // If the category is not selected, add it to the array
                cats = [...selectedCategories.filter(x => x), catSlug];
            }
            if(maxCategories && cats.length > maxCategories) {
                cats.shift();
            }
        }
        
        onChange(cats);
        
    };

    if (loading && categories.length === 0) {
        return (
            <div
                className={[styles.categoriesContainer, align === 'start' ? styles.alignStart : styles.alignCenter, className].filter(Boolean).join(' ')}
                aria-hidden="true"
            >
                {Array.from({ length: 8 }).map((_, index) => (
                    <div key={`category-skeleton-${index}`} className={styles.categoryItem}>
                        <div className={styles.categorySkeleton}>
                            <div className={styles.categorySkeletonCircle} />
                            <div className={styles.categorySkeletonLabel} />
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    return (<div className={[styles.categoriesContainer, align === 'start' ? styles.alignStart : styles.alignCenter, className].filter(Boolean).join(' ')}>
        {showAll && <button
            type="button"
            className={styles.categoryToggle}
            onClick={() => toggleCategory("all")}
            aria-pressed={isSelected("all")}
        >
            <div className={styles.categoryItem}>
                <CategoryButton title={"Toutes"} selected={isSelected("all")} image={getIcon("all")} blue={blue}/>
            </div>
        </button>}
        {categories.map(c =>
                <button
                type="button"
                key={c.slug}
                className={styles.categoryToggle}
                onClick={() => toggleCategory(c.slug)}
                aria-pressed={isSelected(c.slug)}
                >
                <div className={styles.categoryItem}>
                    <CategoryButton title={c.name} selected={isSelected(c.slug)} image={getIcon(c.slug)} blue={blue}/>
                </div>
                </button>
        )}

    </div>);

}

export default CategoryPicker;
